import { render } from "./CardPortfolio.vue?vue&type=template&id=70934664&scoped=true"
import script from "./CardPortfolio.vue?vue&type=script&lang=js"
export * from "./CardPortfolio.vue?vue&type=script&lang=js"

import "./CardPortfolio.vue?vue&type=style&index=0&id=70934664&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70934664"]])

export default __exports__